import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { TuiNotification } from '@taiga-ui/core';

import { PasswordRuleComponent } from '../password-rule/password-rule.component';

interface PasswordRule {
  labelKey: string;
  errorKeys: string[];
}

@Component({
  selector: 'ion-password-rules-panel',
  standalone: true,
  imports: [TuiNotification, PasswordRuleComponent],
  templateUrl: './password-rules-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./password-rules-panel.component.scss'],
})
export class PasswordRulesPanelComponent {
  readonly passwordModel = input.required<NgModel>();
  readonly passwordConfirmModel = input.required<NgModel>();
  readonly resetForm = input.required<NgForm>();
  readonly showError = input.required<boolean>();

  readonly passwordRules: PasswordRule[] = [
    { labelKey: 'LOGIN.PASSWORD_RESET.RULE_MIN_LENGTH', errorKeys: ['required', 'minlength'] },
    { labelKey: 'LOGIN.PASSWORD_RESET.RULE_UPPERCASE', errorKeys: ['required', 'missingUppercase'] },
    { labelKey: 'LOGIN.PASSWORD_RESET.RULE_NUMBER', errorKeys: ['required', 'missingNumber'] },
    { labelKey: 'LOGIN.PASSWORD_RESET.RULE_SPECIAL', errorKeys: ['required', 'missingSpecial'] },
  ];

  hasError(model: NgModel, errorKeys: string[]): boolean {
    return errorKeys.some(key => model.errors?.[key]);
  }
}
